import React from 'react';
import { PageHero } from '../components/PageHero';
import { PostCard } from '../components/blog/PostCard';
import { images } from '../data/images';
import { posts } from '../data/posts';
export function Blog() {
  const [featured, ...rest] = posts;
  return <>
      <PageHero title="Blog" subtitle="Meet Rick Trip & explore Las Vegas" image={images.vegasNeon} data-id="element-245" data-mp="qxak8hq6jxw4" />
      <section className="mx-auto max-w-6xl px-6 py-20" data-id="element-246" data-mp="37ppl1knzc70">
        {featured && <PostCard post={featured} featured data-id="element-247" data-mp="37zfkp5pljcp" />}
        <div className="mt-20 grid gap-x-8 gap-y-16 border-t border-ink-line pt-16 sm:grid-cols-2 lg:grid-cols-3" data-id="element-248" data-mp="3ueiyyspm2hmm">
          {rest.map(post => <PostCard key={post.slug} post={post} data-id="element-249" data-mp="cyu4y2e94z2d" />)}
        </div>
      </section>
    </>;
}